import { Component, OnInit } from '@angular/core';
import { CustomDashboardsService } from 'app/modules/my-limegear/services/my-limegear.service';
import { NoDataActionType } from 'app/modules/shared/interfaces/no-data';
import { ICardInfo } from '../../interfaces/stanalone-components.data';
import { SmallCardService } from '../../services/small-card.service';

@Component({
    selector: 'app-performance-total-headcount-smc',
    templateUrl: './performance-total-headcount-smc.component.html',
    styleUrls: ['./performance-total-headcount-smc.component.scss'],
})
export class PerformanceTotalHeadcountSmcComponent implements OnInit {
    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private _smallcardService: SmallCardService
    ) {}

    cardInfo: ICardInfo;
    ngOnInit(): void {
        this.cardInfo = {
            cardId: 'totalHeadcount',
            title: 'Total Headcount',
            isHeadcount: true,
            type: 'Total',
            cardDrilldownUrl: '/reporting/performance',
        };
        let action = NoDataActionType.pageStart;
        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this.cardInfo.card = this._smallcardService.initializeSmallCard(this.cardInfo, action);
            this.cardInfo.card.urlSegment = 'totalHeadcount';
            this.cardInfo.card.drilldownSegment = 'totalHeadcount';
            this.cardInfo.card.unit = this.cardInfo.units;
            this._smallcardService.preparePerformancePage(
                changes.displayOptions,
                changes.hierarchyfilters,
                this.cardInfo,
                changes.action
            );
        });
    }
}
